import React from "react";
import Accordion from "react-bootstrap/Accordion";

const Faqs = () => {
  return (
    <div>
      <section>
        <div className="container">
          <din className="row mt-3">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>DIGITAL MARKETING</h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. What is meant by digital marketing?
                  </Accordion.Header>
                  <Accordion.Body>
                    Digital marketing refers to online marketing where a brand
                    is translated to connect with its target audience using
                    internet and other related forms of digital communication.
                    Billions of users world-wide engage in the digital world
                    every single day. What could be a better form of marketing
                    than going digital?
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. What are the benefits of digital marketing?
                  </Accordion.Header>
                  <Accordion.Body>
                    Digital marketing is the only way to target your audience at
                    every stage of the buying cycle through proper content
                    strategy and relevant engagement through messages. It can be
                    either through Email marketing or using Social Media etc. as
                    tools. It’s safe to conclude that digital marketing helps
                    you visit arenas of opportunity which a traditional
                    marketing approach may never facilitate.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. Is digital marketing cost-effective?
                  </Accordion.Header>
                  <Accordion.Body>
                    The answer is ‘YES’. Digital marketing is way more
                    cost-effective when compared with traditional ways of
                    marketing. It’s also viable as it allows quantifying the
                    results of your marketing campaigns consequently helping out
                    to make timely and effective decisions.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. What are the different types of digital marketing?
                  </Accordion.Header>
                  <Accordion.Body>
                    A few effective digital marketing approaches are listed
                    below: <br /> a- Social Media Marketing <br /> b- Content
                    Marketing <br />
                    c- Search Engine Optimization (SEO) <br /> d- Paid Per Click
                    (PPC) – Google Ads, Facebook Ads etc. <br /> e- Display
                    Advertisement <br /> Crispbrains has teams of certified and
                    expert professionals who are experienced in handling all the
                    above mentioned digital marketing approaches. Get in touch
                    with us and our teams will go to all lengths to help resolve
                    all your problems related to digital marketing. .
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    5. What is the difference between SEO and SEM?
                  </Accordion.Header>
                  <Accordion.Body>
                    Search Engine Marketing (SEM) refers to a digital marketing
                    strategy used to increase the visibility of a website on
                    search engines like Google, Bing etc. This is done by
                    obtaining traffic through payment through ads. Search Engine
                    Optimization (SEO) on the other hand, attracts traffic from
                    organic search results.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    6. What is the difference between SEO, PPC and SMM?{" "}
                  </Accordion.Header>
                  <Accordion.Body>
                    SEO aims at optimizing the visibility of a given website
                    through attracting organic traffic from search engines by
                    using relevant keywords to attract the target audience. PPC
                    – Paid Per Click is an internet marketing strategy which
                    charges the advertisers a certain amount, a fee, every time
                    a user click their ad. SMM refers to social media marketing.
                    This marketing strategy focus on creating brand awareness
                    amongst the masses which in turn yields customer engagement
                    on different internet platforms The end goal of these
                    strategies is same but each is applied with a different set
                    of techniques and methodologies.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>

          <din className="row mt-5">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>WEB DESIGN AND DEVELOPMENT </h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. How long does it take to design and build a new website?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      It usually depends upon the customer’s general
                      requirements and the technical specifications which differ
                      from customer to customer. Normally, if the content and
                      relevant information is duly provided, we take 8 to 10
                      weeks from receiving an order to launching your website.
                    </p>
                    <p>
                      If you are a small business, we can give you a quicker
                      launch in about 2 to 3 weeks.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. Are your websites SEO friendly?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, this is our priority when designing and launching a
                      website. What is the use of a website if it doesn’t appear
                      easily on search engines anyway?
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. Will I be able to edit the content of my website?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, you will be able to control and edit major parts of
                      your website. Each website comes with a CMS – content
                      management system which facilitates you to edit the texts
                      on pages and add/remove pictures according to your
                      preference.{" "}
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. Are your websites designed to work across different
                    device types?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, our websites are built in a way that they are
                      responsive both on the desktops as well as the mobile
                      devices.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>

          <din className="row mt-5">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>SOCIAL MEDIA MARKETING</h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. What is meant by Social Media Marketing?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Social Media Marketing (SMM) refers to using of social
                      media platforms to market a company’s products and
                      services. This way companies can engage with existing
                      customers and also reach potential new customers.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. What does a Social Media Marketing agency do?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Social Media Marketing agencies work closely with their
                      clients and put in efforts to align social media marketing
                      strategies with those of the company’s desired goals.
                      These agencies act as a crucial means in identifying
                      channels of social media that best suits their clients to
                      reach their desired target markets.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. How can Facebook boost your business?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Facebook is one of a kind social media platform which
                      offers businesses the opportunity to create brand
                      awareness and reach new customers, generate leads and
                      eventually increase sales. So, it can be safely
                      established that Facebook is an important social media
                      tool that has a high potential to give boost to any given
                      business.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. How can I attract customers on Facebook?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Maintain active social presence on Facebook helps
                      immensely in attracting new customers and retaining
                      existing ones. Your social media handle should keep the
                      audience engaged by posting strategically smart content
                      that is informational, engaging and visually appealing.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    5. How can I improve my Facebook Ads performance?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Facebook’s advertising statistics is a great way to check
                      and improve your business’s marketing strategy related to
                      Facebook ads performance. You can easily observe the
                      response rate to the ads and also broaden up or narrow
                      down your audience if you think you are approaching the
                      mix of target audience until you get to your desired
                      result.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    6. How do you effectively advertise on Facebook and is it
                    worth it?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Paid Advertisement, creating a marketing strategy
                      alongside a reasonable budget and learning from Audience
                      Insight is the correct way to effectively advertise on
                      Facebook. Once your business has gained it’s desired
                      footprint in the digital world, the benefits are numerous
                      and it’s definitely worth it.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>

          <din className="row mt-5">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>SEO</h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. Can you optimize any type of website?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, our team at Crispbrains comprises of experts in each
                      related filed of digital marketing and we are able to work
                      with a wide range of websites.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. Can you guarantee my website will appear on page one of
                    Google?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Actually, no one can guarantee that! However, we aim to
                      increase targeted traffic that drives people to your
                      website that are actively looking for your
                      products/services. Hence, we focus on leads that convert
                      to genuine sales and you should too.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. How long does SEO take to start working?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      We usually suggest to wait for at least a period of 3 to 6
                      months to observe any significant results from your
                      campaigns. Though, like anyone else, we look out for quick
                      wins for our clients, Search Engine Optimization is a
                      long-term investment. The result depends upon the work
                      required and your industry competitiveness.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. How much should one spend on SEO?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      As with any other marketing strategy, your investment
                      directly correlates with what you want to achieve and the
                      time-frame of expected results.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    5. Are SEO companies worth it?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Simply speaking, it actually depends upon how much do you
                      value your time. The truth is; SEO, when done the right
                      way, provides and impressive return on investment. This
                      means, having the right strategy in place and working with
                      the experts in the field. In other words, you keep a good
                      maintenance on your website, just like your car, and your
                      website will help your business run smoothly.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    6. What does an SEO agency do?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      An SEO agency specializes in this marketing technique and
                      promotes companies appearance on search engines like
                      Google and Bing. The agency will devise a marketing
                      strategy in accordance with yours requirement and
                      objectives, and work through these in order to optimize
                      your website
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>

          <din className="row mt-5">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>PPC</h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>1. Is PPC expensive?</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      PPC can actually be quite cost-effective because you get
                      to pay only when a user clicks an advert to reach your
                      website. All you need to do is keep the performance under
                      review and intelligently target your keywords. PPC
                      campaigns also have an option to pause and review the
                      overall campaign results for further evaluation.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. How much should you spend on PPC?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      We can only suggest a minimum budgeted amount for PPC
                      campaign after evaluating your industry and market
                      competitiveness.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. What do PPC services include?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Our PPC services usually include initial business audit
                      and market research, setting up the account, selecting
                      related keywords and creating an ad copy.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. How long does PPC take to start working?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      As soon as PPC campaigns are launched, they will
                      immediately start pushing relevant traffic onto your
                      website hence providing instant feedback as a result.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    5. Are PPC companies worth it?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Though PPC campaigns can be self-manageable but keeping a
                      dedicated team to look after it can be a worthwhile
                      decision. Expert tackling your PPC account can become a
                      game-changer offering you an optimal level of performance
                      and consequently resulting in a better ROI on the Ad
                      related costs.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    6. What does a PPC agency do?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A PPC agency specializes in Pay-Per-Click marketing. Their
                      expert teams manage your account and help reach your
                      targeted KPI’s by managing your search campaigns. They can
                      help you achieve better returns on your Ad expenditures.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>

          <din className="row mt-5">
            <div className="col-md-12">
              <div className="faq_heading text-center">
                <h2>CONTENT MARKETING</h2>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. How do you market content?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Content Marketing involves creation and timely sharing of
                      relevant information online such as articles, blogs,
                      social media posts, info-graphics, videos and images to
                      stimulate target audience’s interest and divert them to a
                      destined visual location such as a specific website.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. What does a content strategist do?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A content strategist is responsible for planning,
                      designing, creating and publishing relevant content based
                      on the business’s requirements and user’s needs. It is
                      his/her job to understand the business’s objectives and
                      then formulate a content plan in accordance with these
                      objectives in order to achieve a specific goal.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    3. How can a content marketing strategy be improved?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      It can improved be gaining and retaining trust of the
                      customers by producing and sharing relevant, reliable and
                      consistent content that can be distributed via a variety
                      of different channels.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    4. What are the best ways to do content marketing?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Create a fully researched content calendar that aligns
                      perfectly with the business objectives and implement it
                      while carefully monitoring its feedback. A good content
                      includes creating original, thought-provoking and engaging
                      content that includes attractive images and videos.
                      Content that caters to your customer’s problems and
                      provides a reliable solution.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    5. What is a content marketing strategy?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Content marketing strategy is a form of marketing where
                      target audience is attracted, engaged and retained via
                      creating and sharing relevant articles, videos, blogs,
                      podcasts and other media tools. This approach promotes
                      brand awareness and helps keep constant engagement with
                      your customers.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </din>
        </div>
      </section>
    </div>
  );
};

export default Faqs;
